import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';
import { FeatherModule } from 'angular-feather';

@Component({
  selector: 'app-alert-toast-component',
  styleUrls: ['alert.component.scss'],
  templateUrl: 'alert.toast.html',
  preserveWhitespaces: false,
  imports: [FeatherModule],
})
export class AlertToastComponent extends Toast {
  iconName: string | null = null;
  private typesStyles = new Map<string, string>([
    ['toast-success', 'check-circle'],
    ['toast-warning', 'alert-triangle'],
    ['toast-error', 'alert-circle'],
  ]);

  constructor() {
    super();
    this.setTypeStyle(this.toastPackage.toastType);
  }

  private setTypeStyle(type: string): void {
    const typeAvailable = this.typesStyles.has(type);
    if (typeAvailable) {
      this.iconName = this.typesStyles.get(type)!;
    }
  }
}
